import api from "@/api";
import Sector from "@/types/Sector";
import Reservation from "@/types/Reservation";
import { AxiosResponse } from "axios";

interface Payload {
  event_id: string;
  token: string;
  sectors: Sector[];
}

export default async function reserveTickets(data: Payload): Promise<Reservation> {
  const response: AxiosResponse<Reservation> = await api.post(`/api/checkout/reserve`, {
    ...data,
    // TODO:(legacy-batches) there's gotta be a better way of doing this lol
    sectors: data.sectors.map(sector => ({
      ...sector,
      sections: sector.sections.map(section => ({
        ...section,
        tickets: section.tickets.map(ticket => ({
          ...ticket,
          batch_id: ticket.current_batch?.id ?? null,
        })),
      })),
    })),
  });

  return response.data;
}
